import { cn } from '@shared/lib/cn';

import { DIALOG_SKELETON_LINES_WIDTH, DIALOG_SKELETON_TITLE_WIDTH } from './dialog.constant';

const BAR_CLASS = 'block max-w-full rounded-full bg-bg-pressed';

/** Dialog status=init 의 제목 자리 — 200×20 막대 */
export function DialogTitleSkeleton() {
  return (
    <span
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', BAR_CLASS, 'h-5')}
      style={{ width: DIALOG_SKELETON_TITLE_WIDTH }}
    />
  );
}

export interface DialogBodySkeletonProps {
  /** 막대 너비(px 또는 CSS 길이). 기본 Dialog 의 392 · 392 · 235(`size.skeleton.*`) */
  lines?: readonly (number | string)[];
  className?: string;
}

/** Dialog · AlertDialog status=init 의 본문 자리 — 12 높이 막대 3줄(간격 8) */
export function DialogBodySkeleton({
  lines = DIALOG_SKELETON_LINES_WIDTH,
  className,
}: DialogBodySkeletonProps) {
  return (
    <span
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', 'flex flex-col gap-2', className)}
    >
      {lines.map((width, index) => (
        <span key={index} className={cn(BAR_CLASS, 'h-3')} style={{ width }} />
      ))}
    </span>
  );
}
